import { ValidateTransactionResponse } from "@ac-expo/api-types";
import { Button } from "@ac-expo/ui-components";
import { OrderStatus } from "@prisma/client";
import { useEffect, useRef } from "react";
import { STEPS } from "./EmbedTicketing";
import { CartStatus } from "@web-app/src/components/Cart/CartPanel";
import { useUserContext } from "@web-app/src/context/auth/user.context";
import { EmbedPayOnSiteLink } from "./EmbedPayOnSiteLink";

type Props = {
  setStep: (step: STEPS) => void;
  resetPreviousForms: () => void;
  result: ValidateTransactionResponse | null;
  eventSlug: string | null;
};

export function EmbedConfirmationComponent({
  setStep,
  resetPreviousForms,
  result,
  eventSlug,
}: Props) {
  const { disconnect } = useUserContext();
  const shouldDisconnectOnUnmount = useRef(true);

  useEffect(() => {
    return () => {
      if (shouldDisconnectOnUnmount.current) {
        disconnect();
      }
    };
  }, [disconnect]);

  if (!result) {
    return (
      <div className="flex flex-col items-center justify-center gap-2">
        <p className="text-center text-lg">
          Une erreur est survenue dans votre commande, veuillez réessayer.
        </p>
        <EmbedPayOnSiteLink eventSlug={eventSlug} />
      </div>
    );
  }

  return (
    <CartStatus
      order={{
        id: result.id,
        reference: result.reference,
        status: result.status,
      }}
      disableDescription
    >
      <>
        {result.status === OrderStatus.success && (
          <>
            <p className="text-center text-xs">
              Pensez à conserver la référence de votre commande.
              <br />
              Vous pouvez retrouver la facture ainsi que vos billets sur
              Connect&apos;Events.
            </p>
          </>
        )}
        {result.status === OrderStatus.canceled && <p>Annulé</p>}
        {result.status === OrderStatus.processing && <p>En cours</p>}
        {result.status === OrderStatus.refused && <p>Refusé</p>}
        <div className="mt-2 flex flex-row gap-2">
          <Button
            variant="blue"
            onClick={() => {
              shouldDisconnectOnUnmount.current = false;
              setStep("CART");
              resetPreviousForms();
            }}
          >
            Acheter à nouveau
          </Button>
        </div>
        {result.status !== OrderStatus.success && (
          <EmbedPayOnSiteLink eventSlug={eventSlug} />
        )}
      </>
    </CartStatus>
  );
}
